jQuery(function($) {
    $('.tabs-module .tabs-module-link').on('click', function(e) {
        e.preventDefault();
        $('.tabs-module .tabs-module-link').removeClass('tabs-active');
        $(this).addClass('tabs-active');
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/modules/tabs-module.js
// module id = 24
// module chunks = 0